import script from "./NewsBySourceChart.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsBySourceChart.vue?vue&type=script&setup=true&lang=js"

import "./NewsBySourceChart.vue?vue&type=style&index=0&id=0cd590a7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cd590a7"]])

export default __exports__